/** Age in whole years from a birth date (locale-independent). */
export const calculateAgeFromBirthDate = (birthDate: Date): number => {
  const currentDate = new Date();
  const ageInMilliseconds = currentDate.getTime() - birthDate.getTime();
  const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
  return Math.floor(ageInMilliseconds / millisecondsInYear);
};

/** Normalize Date, dayjs-like values, or legacy locale date strings for age calculation. */
export const toBirthDate = (value: unknown): Date | null => {
  if (value == null || value === "") return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }

  if (typeof value === "object" && value !== null && "$d" in value) {
    const dayjsDate = new Date((value as { $d: string | Date }).$d);
    return Number.isNaN(dayjsDate.getTime()) ? null : dayjsDate;
  }

  if (typeof value === "string") {
    const slashParts = value.split("/");
    if (slashParts.length === 3) {
      const [a, b, c] = slashParts.map((part) => parseInt(part, 10));
      if ([a, b, c].some((part) => Number.isNaN(part))) return null;

      // Legacy callers assumed MM/DD/YYYY; also accept DD/MM/YYYY when unambiguous.
      let month = a;
      let day = b;
      let year = c;
      if (a > 12 && b <= 12) {
        day = a;
        month = b;
      }

      const parsed = new Date(year, month - 1, day);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
};

export const calculateAge = (value: unknown): number | null => {
  const birthDate = toBirthDate(value);
  if (!birthDate) return null;
  return calculateAgeFromBirthDate(birthDate);
};
